import {TPublishNote} from "@/index";

let publishNote:any;

export function initPublishNote(db){
    publishNote = db.table('publishNote');
}

/**
 * 更新NOTE
 * @param note
 */
export function updatePublishNote(note:TPublishNote){
    publishNote.put(note);
}

export function deletePublishNote(id:string){
    publishNote.delete(id);
}

export function getPublishNoteById(id:string){
    return publishNote.get(id);
}

/**
 * 获取发布的列表...
 */
export function getPublishNoteListInPublish(){
    return publishNote.toArray();
}